import { IconButton, Tooltip, Typography } from '@material-ui/core'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import React from 'react'
import { sanitizeDescriptionHtml } from '../../../lib/htmlDescriptionUtility'

interface DifferenceTooltipProps {
  title: string

  isHtml?: boolean
}

export const DifferenceTooltip = ({title, isHtml = false}: DifferenceTooltipProps) => {
  const tooltipTitle = isHtml
    ? (
      <span>
        <Typography variant="caption" display="block" gutterBottom>
          Значение на маркетплейсе:
        </Typography>
        <span dangerouslySetInnerHTML={{__html: sanitizeDescriptionHtml(title)}}/>
      </span>
    )
    : `Значение на маркетплейсе: ${title}`

  return (
    <Tooltip title={tooltipTitle}>
      <IconButton size="small" style={{color: 'red'}}>
        <ReportProblemOutlinedIcon fontSize={'inherit'}/>
      </IconButton>
    </Tooltip>
  )
}
